import React from 'react';
import PropTypes from "prop-types";

const User = ({user, index, toggleActivation, openModal}) => {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function getRoleDisplayName(role) {
    switch (role) {
      case 'general':
        return `${capitalizeFirstLetter(role)} User`;
      case 'warehouse':
        return `${capitalizeFirstLetter(role)} Admin`;
      default:
        break;
    }
  }

  function getUserDisplayName(firstName, lastName) {
    return `${firstName} ${lastName}`;
  }

  return (
      <tr>
        <td>{index + 1}</td>
        <td>{getUserDisplayName(user.user.first_name, user.user.last_name)}</td>
        <td>{user.user.email}</td>
        <td>{getRoleDisplayName(user.user.role)}</td>
        <td>
          <ul className="action-icons">
            <li>
              <label className="switch">
                <input type="checkbox" checked={user.user.is_active}
                       onChange={() => toggleActivation(user.user.id, user.user.is_active)}/>
                <span className="slider round"/>
              </label>
            </li>
            <li>
              <button type="button" className="delete-staff" data-target=".delete-staff-modal" data-toggle="modal"
                      onClick={() => openModal('delete', user.user.id)}>
                <i className="icon-delete"/>
              </button>
            </li>
          </ul>
        </td>
      </tr>
  );
};

User.propTypes = {
  user: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  toggleActivation: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

export default User;



// WEBPACK FOOTER //
// ./src/components/UsersList/User.jsx